import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { Week } from '@app/components/Calendars/components/MonthGrid/components';
import { useMonthGrid } from '@app/components/Calendars/components/MonthGrid/hooks/useMonthGrid';
import type { MonthGridType } from '@app/components/Calendars/components/MonthGrid/types';
import { LoadingBox } from '@app/components/LoadingBox';
import '@app/components/Calendars/components/MonthGrid/styles/MonthGrid.desktop.scss';
import '@app/components/Calendars/components/MonthGrid/styles/MonthGrid.tablet.scss';

export const MonthGrid: MonthGridType = ({ isLoading }) => {
  const { monthWeeks, currentMonth } = useMonthGrid();
  return (
    <div className={`${CV_PREFIX}-month-grid-container`}>
      <LoadingBox isLoading={isLoading} />
      <div className="empty-space" />
      <div className={`${CV_PREFIX}-month-grid`}>
        {monthWeeks.map((week, index) => (
          <Week
            key={week.id}
            {...week}
            isBottomWeek={
              index === monthWeeks.length - 1 || index === monthWeeks.length - 2
            }
            {...currentMonth}
          />
        ))}
      </div>
      <div className="empty-space" />
    </div>
  );
};
